import {ImageDefaultStore} from "../stores/models";
import OnboardingStore, {IOnboardingStore, OnboardingDefaultStore} from "../stores/OnboardingStore";
import LandingPageStore, {ILandingPageStore} from "../stores/LandingPageStore";
import {Base64} from "js-base64";
import {ItemWithAvatar} from "../screens/LandingPageScreen";
import {formatI18nKeys} from "./I18n";

export function createImageStoreWithRemoteUrl(url: string | null):any {
    return url ? {
        ...ImageDefaultStore,
        url: url,
        path: url,
        isLocalImage: false
    } : null;
}

const extractOnboardingStore = (value: any) => ({
    title: value.title,
    subtitle: value.subtitle,
    color: value.fontColor,
    backgroundColor: value.backgroundColor,
    backgroundImage: createImageStoreWithRemoteUrl(value.backgroundImage),
    image: createImageStoreWithRemoteUrl(value.image)
});

const extractLandingPageStore = (value: any) => ({
    tagline: value.tagline,
    textColor: value.fontColor,
    backgroundColor: value.backgroundColor,
    logo: createImageStoreWithRemoteUrl(value.logo),
    backgroundImage: createImageStoreWithRemoteUrl(value.backgroundImage)
});

interface PreviewProps {
    firstScreenStore: IOnboardingStore,
    secondScreenStore: IOnboardingStore,
    landingPageStore: ILandingPageStore,
    user: ItemWithAvatar,
    group: any,
    previewHint: string
}

export function generatePreviewObject(previewBase64: string): PreviewProps {

    const preview = previewBase64 && JSON.parse(Base64.decode(previewBase64));

    const firstScreenStore = preview.introScreens && preview.introScreens.length
        ? extractOnboardingStore(preview.introScreens[0])
        : OnboardingDefaultStore;
    const secondScreenStore = preview.introScreens && preview.introScreens.length > 1
        ? extractOnboardingStore(preview.introScreens[1])
        : OnboardingDefaultStore;
    const landingPageStore = extractLandingPageStore(preview);

    const previewHint = formatI18nKeys(preview.creator ? "shared_preview_screen_hint" : "shared_preview_screen_hint_unauthenticated", ...preview.creator ? [preview.creator, preview.group.name] : [preview.group.name]);

    return {
        firstScreenStore: OnboardingStore.create(firstScreenStore),
        secondScreenStore: OnboardingStore.create(secondScreenStore),
        landingPageStore: LandingPageStore.create(landingPageStore),
        user: preview.user,
        group: preview.group,
        previewHint
    };

}
